import React, { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { DOCUMENT_TYPE_OPTIONS, OTHER_DOCUMENT_TYPE } from './fundingDocumentTypes';

const FundingDocumentTypeSelector = ({
  value = [],
  onChange,
  id,
  label = 'Document types',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = Array.isArray(value) ? value : [];

  const toggleType = (type) => {
    if (selected.includes(type)) {
      onChange?.(selected.filter((item) => item !== type));
      return;
    }
    onChange?.([...selected, type]);
  };

  React.useEffect(() => {
    const handleClick = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="fg-doc-type-selector" ref={rootRef}>
      <label htmlFor={id}>{label}</label>
      <button
        type="button"
        id={id}
        className="fg-doc-type-selector__trigger"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{selected.length ? `${selected.length} selected` : 'Select document types'}</span>
        <ChevronDown className="size-4" />
      </button>
      {selected.length > 0 ? (
        <div className="fg-doc-type-chips">
          {selected.map((type) => (
            <button
              key={type}
              type="button"
              className="fg-doc-type-chip"
              onClick={() => toggleType(type)}
            >
              {type}
              <span aria-hidden="true">×</span>
            </button>
          ))}
        </div>
      ) : null}
      {open ? (
        <div className="fg-doc-type-selector__menu" role="listbox" aria-multiselectable="true">
          {DOCUMENT_TYPE_OPTIONS.map((type) => (
            <label key={type} className="fg-doc-type-selector__option">
              <input
                type="checkbox"
                checked={selected.includes(type)}
                onChange={() => toggleType(type)}
              />
              <span>{type}</span>
            </label>
          ))}
        </div>
      ) : null}
      {selected.includes(OTHER_DOCUMENT_TYPE) ? (
        <p className="fg-doc-type-selector__hint">Add a custom document name on the file card.</p>
      ) : null}
    </div>
  );
};

export default FundingDocumentTypeSelector;
